(function($) {
    var defaultOptions = {
        errorClass: "erro",
    };
    $.validator.setDefaults(defaultOptions);
    $.validator.unobtrusive.options = {
        errorClass: defaultOptions.errorClass,
        invalidHandler: function(event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                var summary = "";
                $.each(validator.errorList, function() { summary += " * " + this.message + "<br>"; });
                global.showErrorMessage(summary);
            }
        }
    };
})(jQuery);

$.fn.getXPath = function (rootNodeName) {
	//other nodes may have the same XPath but because this function is used to determine the corresponding input name of a data node, index is not included 
	var position,
        $node = this.first(),
        nodeName = $node.prop("nodeName"),
        $sibSameNameAndSelf = $node.siblings(nodeName).addBack(),
        steps = [],
        $parent = $node.parent(),
        parentName = $parent.prop("nodeName");

	position = ($sibSameNameAndSelf.length > 1) ? "[" + ($sibSameNameAndSelf.index($node) + 1) + "]" : "";
	steps.push(nodeName + position);

	while ($parent.length == 1 && parentName !== rootNodeName && parentName !== "#document") {
		$sibSameNameAndSelf = $parent.siblings(parentName).addBack();
		position = ($sibSameNameAndSelf.length > 1) ? "[" + ($sibSameNameAndSelf.index($parent) + 1) + "]" : "";
		steps.push(parentName + position);
		$parent = $parent.parent();
		parentName = $parent.prop("nodeName");
	}
	return "/" + steps.reverse().join("/");
};

(function (jQuery) {
	jQuery.fn.hasAttr = function (name) {
		for (var i = 0, l = this.length; i < l; i++) {
			if (!!(this.attr(name) !== undefined)) {
				return true;
			}
		}
		return false;
	};
})(jQuery);